import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "../../assets/css/home-page.css";

const SliderCard = ({ data }) => {
  const { bgImg, highlight, name, details, type } = data;
  
  // Memoize the JSON string to prevent unnecessary re-renders
  const json_data = useMemo(() => JSON.stringify(data), [data]);

  // Use inline styles with proper background image loading
  const backgroundStyle = useMemo(() => ({
    backgroundImage: `url(${bgImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }), [bgImg]);

  return (
    <div className="slider" style={backgroundStyle}>
      <div className="slide_content">
        <div className="slide_content_wrapper">
          <div className="slide_content_inner">
            {/* Project Category - only show highlight if not "NONE" */}
            {highlight && highlight !== "NONE" && (
              <div className="project-category">
                {highlight}
              </div>
            )}
            
            {/* Project Name */}
            <h2 className="project-name">{name}</h2>
            
            {/* Project Description (only on medium screens and up) */}
            {details && (
              <div className="project-excerpt d-none d-md-block">
                {details.length > 100 ? `${details.substring(0, 100)}...` : details}
              </div>
            )}
            
            {/* View Details Link */}
            <div className="view-project">
              <Link 
                to="/project-details" 
                state={json_data}
                aria-label={`View details of ${name} project`}
              >
                View Details
                <i className="bi bi-arrow-right ms-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SliderCard;
